import { BooleanField, Datagrid, List, TextField, TextInput } from "react-admin";


const filter = [<TextInput source="name" alwaysOn label={'Nome'} />]


const InstitutionList = ({ permissions, ...props }) =>
  <List
    filters={filter}
    exporter={false}
    bulkActionButtons={false}
    title={'Instituições'}
    sort={{ field: 'name', order: 'ASC' }}
    {...props}
  >
    <Datagrid rowClick={'edit'}>
      <TextField source="name" label={'Nome'} />
      <TextField source="cnpj" label={'CNPJ'} />
      <TextField source="slug" label={'slug'} />
      <BooleanField source="active" label={'Ativa'} />
    </Datagrid>
  </List>

export default InstitutionList;